var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.39 6.512l2.96-3.7A.5.5 0 006.96 2H1.04a.5.5 0 00-.39.812l2.96 3.7c.2.25.58.25.78 0z",
    fill: "#262A33",
    fillOpacity: 0.5
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgOCA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNNC4zOTA0MyA2LjUxMTk2TDcuMzUwMTIgMi44MTIzNUM3LjYxMjAzIDIuNDg0OTcgNy4zNzg5NCAyIDYuOTU5NjkgMkwxLjA0MDMxIDJDMC42MjEwNiAyIDAuMzg3OTc0IDIuNDg0OTcgMC42NDk4NzkgMi44MTIzNUwzLjYwOTU3IDYuNTExOTZDMy44MDk3MyA2Ljc2MjE2IDQuMTkwMjcgNi43NjIxNiA0LjM5MDQzIDYuNTExOTZaIiBmaWxsPSIjMjYyQTMzIiBmaWxsLW9wYWNpdHk9IjAuNSIvPgo8L3N2Zz4K";
export { SvgArrowDown as ReactComponent };